import { render, staticRenderFns } from "./ProductShippingDetails.vue?vue&type=template&id=1f29efcc&scoped=true&"
import script from "./ProductShippingDetails.vue?vue&type=script&lang=js&"
export * from "./ProductShippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductShippingDetails.vue?vue&type=style&index=0&id=1f29efcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29efcc",
  null
  
)

export default component.exports